import { Box, Drawer, Typography, ButtonBase } from '@mui/material';
import { styled } from '@mui/material/styles';

export const StyledDrawer = styled(Drawer)(() => ({
  '& .MuiDrawer-paper': {
    width: '100%',
    maxWidth: 480,
    padding: '24px',
    boxSizing: 'border-box',
    overflowY: 'auto',
    display: 'flex',
    flexDirection: 'column',
    gap: '0px',
  },
}));

export const DrawerHeader = styled(Box)(() => ({
  display: 'flex',
  justifyContent: 'flex-end',
  marginBottom: '8px',
  '& span': { fontSize: '24px' },
}));

export const DrawerTitleRow = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  marginTop: '16px',
  marginBottom: '8px',
}));

export const DrawerTitle = styled(Typography)(({ theme }) => ({
  fontSize: '21px',
  fontWeight: 600,
  color: theme.palette.secondary.main,
}));

export const DrawerSubtitle = styled(Typography)(() => ({
  color: '#595959',
  marginBottom: '24px',
}));

export const DrawerActions = styled(Box)(() => ({
  display: 'flex',
  gap: '16px',
  marginTop: '24px',
  justifyContent: 'space-between',
}));

export const DeleteDoc = styled(ButtonBase)(({ theme }) => ({
  display: 'flex',
  gap: '10px',
  border: '1px solid #FF4C4C',
  borderRadius: '30px',
  color: '#FF4C4C',
  fontWeight: 500,
  padding: '14px 16px',
  fontSize: 16,
  '&:hover': {
    color: theme.palette.common.white,
    backgroundColor: '#FF4C4C',
  },
}));
